import React from 'react'
import { useNavigate } from 'react-router-dom'
import BotImage from '@/assets/bot-timer-tip.png'
import { Button, Column, Text } from '@/components/core'
import AvatarCard from '@/components/layout/AvatarCard.tsx'
import { ROUTES } from '@/types/routes.ts'

const TimerTip: React.FC = () => {
  const navigate = useNavigate()
  return (
    <AvatarCard variant="image" botAvatar={BotImage} animate>
      <Column className="h-full flex-1">
        <Column className="flex-1 items-center">
          <Column className="w-full flex-1 items-center space-y-5">
            <Text.Translated
              color="600"
              fontWeight="bold"
              className="max-sm:text-xl sm:text-2xl"
              translationKey="last_thing_setup_states_timer_tip"
            />
            <Column className="items-center">
              <Text
                color="600"
                align="center"
                className="max-w-[504px] max-sm:max-w-[280px] max-sm:text-base"
              >
                <Text.Translated
                  className="inline"
                  translationKey="timer_message_part1_setup_states_timer_tip"
                />{' '}
                <Text.Translated
                  color="600"
                  fontWeight="bold"
                  className="inline max-sm:text-base"
                  translationKey="twenty_seconds_setup_states_timer_tip"
                />{' '}
                <Text.Translated
                  className="inline"
                  translationKey="timer_message_part2_setup_states_timer_tip"
                />
              </Text>
            </Column>
          </Column>
          <Column className="mx-16 w-full max-w-[360px] justify-center">
            <Button.Translated
              onClick={() => navigate(ROUTES.ONBOARDING.READY_TO_START)}
              translationKey="start_warmup_setup_states_timer_tip"
            />
          </Column>
        </Column>
      </Column>
    </AvatarCard>
  )
}

export default TimerTip
